<template>
    <div class="section">
        <v-container class="px-10">
            <v-row cols="12" justify="center">
                <v-col cols="12" md="8" class="px-10">
                    <h1 class="mb-5 text-center mb-7 text-bold text-h4 font-weight-bold">Global Reach with Instant Translation</h1>
                    <div class="text-center" style="font-size: 1.2em;">
                        Break down language barriers with <b>automatic text translation</b> across <b>SMS, MMS, Email, and Chat</b>. Serve customers in their preferred language—without extra effort from your team.
                    </div>
                    
                </v-col>
            </v-row>
            <v-row cols="12" justify="center">
                <div class="main">
                    
                    <div class="circle"><div class="inner">Hello</div></div>
                    <div class="circle"><div class="inner">Hola</div></div>
                    <div class="circle"><div class="inner">Bonjour</div></div>
                    <div class="circle"><div class="inner">こんにちは</div></div>
                    <div class="circle"><div class="inner">안녕하세요</div></div>
                    <v-icon size="70px" color="primary">mdi-translate</v-icon>
                </div>
            </v-row>
        </v-container>
    </div>
</template>
<script>
export default {
    name: 'ChatTranslation'
}
</script>

<style lang="scss">
$radius: 200px;
.main {
    position: relative;
    border: 20px solid #1582d8;
    border-radius: 50%;
    width: $radius * 2;
    height: $radius * 2;
    margin-top: 5em;
    display: flex;
    align-items: center;
    justify-content: center;
}
$items: 5;
$size: 150px;
$startAngle: 90deg;

.circle {
    position: absolute;
    left: calc(50% - #{$size} / 2);
    top: calc(50% - #{$size} / 2);
    height: $size;
    font-size: 1.7em;
    text-align: center;
    width: $size;
    z-index: 2;
    background-color: white;
    border: 3px solid #1582d8;
    border-radius: 10px;
    color: #1582d8;
    display: flex;
    align-items: center;
    justify-content: center;
    
    @for $i from 1 through $items {
        $angle: 360deg / $items * $i - $startAngle;
        @keyframes spin#{$i} {
            from { transform: rotate($angle) translateX($radius) rotate(-$angle); }
            to { transform: rotate($angle + 360deg) translateX($radius) rotate(-$angle - 360deg); }
        }
        &:nth-child(#{$i}) {
            transform: rotate($angle) translateX($radius) rotate(-$angle);
            animation: spin#{$i} 30s linear infinite;
        }
    }

    &:hover .inner {
        font-weight: bold;
        transition: font-weight 0.1s ease-in-out;
    }
}

</style>